const gtag = (...args) => {
  if (window.gtag) window.gtag(...args);
};

export const trackPageView = (path) => {
  gtag('event', 'page_view', { page_path: path });
};

export const trackEvent = (eventName, params = {}) => {
  gtag('event', eventName, params);
};

// list: melyik listából jött a kattintás (pl. 'home_featured', 'home_category_fenykepeszek'), ha nem a fő lista
export const trackProviderCardClick = (slug, category, position, list) => {
  gtag('event', 'provider_card_click', { provider_slug: slug, category, list_position: position, ...(list && { list_name: list }) });
};

export const trackProviderView = (slug, category) => {
  gtag('event', 'provider_view', { provider_slug: slug, category });
};

export const trackProviderEditView = (providerId) => {
  gtag('event', 'provider_edit_view', { provider_id: providerId });
};

export const trackProviderSectionSave = (providerId, section) => {
  gtag('event', 'provider_section_save', { provider_id: providerId, section });
};

export const trackFormOpen = (providerSlug) => {
  gtag('event', 'offer_form_open', { provider_slug: providerSlug });
};

export const trackFormSubmit = (providerSlug) => {
  gtag('event', 'offer_form_submit', { provider_slug: providerSlug });
};

export const trackGalleryOpen = (providerSlug) => {
  gtag('event', 'gallery_open', { provider_slug: providerSlug });
};

export const trackPackageView = (packageId) => {
  gtag('event', 'package_view', { package_id: packageId });
};

export const trackRegister = () => {
  gtag('event', 'sign_up', { method: 'email' });
};

export const trackLogin = (method = 'email') => {
  gtag('event', 'login', { method });
};

// ─── Saját backend analytics (szolgáltató statisztikák) ───────────────────────

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

export const ANALYTICS_EVENTS = {
  PROFILE_VIEW:       'PROFILE_VIEW',
  QUICK_VIEW_OPEN:    'QUICK_VIEW_OPEN',
  GALLERY_SWIPE:      'GALLERY_SWIPE',
  CONTACT_REVEAL:     'CONTACT_REVEAL',
  CONTACT_LINK_CLICK: 'CONTACT_LINK_CLICK',
  SOCIAL_CLICK:       'SOCIAL_CLICK',
  OFFER_REQUEST:      'OFFER_REQUEST',
  TIME_ON_PROFILE:    'TIME_ON_PROFILE',
};

/**
 * Esemény rögzítése a szolgáltató statisztikájához.
 * Fire-and-forget: soha nem dob hibát, nem blokkolja a UI-t.
 * keepalive: true → TIME_ON_PROFILE esetén page close után is elküldhető.
 */
export const trackProviderEvent = (eventType, providerId, metadata = null) => {
  if (!providerId || !eventType) return;
  const body = JSON.stringify({
    providerId,
    eventType,
    ...(metadata && { metadata }),
  });
  fetch(`${BACKEND_URL}/api/analytics/event`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => {});
};

let gallerySwipeTimer = null;
export const trackGallerySwipe = (providerId, action, sessionId = null) => {
  clearTimeout(gallerySwipeTimer);
  gallerySwipeTimer = setTimeout(() => {
    const metadata = sessionId ? { action, sessionId } : { action };
    trackProviderEvent(ANALYTICS_EVENTS.GALLERY_SWIPE, providerId, metadata);
  }, 500);
};

// ─── Főoldali megjelenések ──────────────────────────────────────────────────
// A kártyák láthatóvá válását gyűjtjük, és kötegelve küldjük (POST /api/analytics/home-impressions).
// Oldalmegtekintésenként (a főoldal mountolásától) egy szolgáltató sávonként egyszer számít.
const HOME_IMPRESSION_FLUSH_MS = 4000;
const HOME_IMPRESSION_BATCH_MAX = 60; // a backend kérésenkénti korlátja
let homeImpressionQueue = [];
let homeImpressionTimer = null;

export const flushHomeImpressions = () => {
  clearTimeout(homeImpressionTimer);
  homeImpressionTimer = null;
  while (homeImpressionQueue.length > 0) {
    const impressions = homeImpressionQueue.splice(0, HOME_IMPRESSION_BATCH_MAX);
    fetch(`${BACKEND_URL}/api/analytics/home-impressions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ impressions }),
      keepalive: true, // lapbezáráskor / navigáláskor is elmenjen
    }).catch(() => {});
  }
};

export const trackHomeImpression = (providerId, band) => {
  if (!providerId || !band) return;
  homeImpressionQueue.push({ providerId, band });
  if (!homeImpressionTimer) homeImpressionTimer = setTimeout(flushHomeImpressions, HOME_IMPRESSION_FLUSH_MS);
};

// API wrapper-ek a statisztika oldalhoz (hitelesítést az apiService kezeli)
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchProviderStats = async (startDate, endDate) => {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  const res = await fetch(`${BACKEND_URL}/api/analytics/my-stats?${params}`, {
    headers: getAuthHeaders(),
  });
  return res.json();
};

export const fetchProviderStatsSummary = async (startDate, endDate) => {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  const res = await fetch(`${BACKEND_URL}/api/analytics/my-stats/summary?${params}`, {
    headers: getAuthHeaders(),
  });
  return res.json();
};
